var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-search-bar"},_vm._l((_vm.list),function(row){return _c('div',{key:row.tagId,staticClass:"tag",on:{"click":function($event){return _vm.handleSearch(row)}}},[_vm._v(_vm._s(row.tagName))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }